// src/utils/futureIncome.js - plan_25
// Whether a planned future income payment counts in projections.
//
// With "Count next year's income in projections" switched off
// (budget_settings.future_income_this_year_only), a payment dated in a later
// year than the one you're looking at stays out until that year. App sets the
// rule from your settings each time it draws, before any tab works anything
// out, so every projection reads the same answer.

let thisYearOnly = false;

export const setFutureIncomeRule = (on) => { thisYearOnly = !!on; };
export const isThisYearOnly = () => thisYearOnly;

// `year` is the year being looked at (the month arrows on Wealth); without
// one it's this year.
export const countsInProjection = (payment, year = null) => {
  if (!thisYearOnly || !payment || !payment.expected_date) return true;
  const y = Number(String(payment.expected_date).slice(0, 4));
  if (!y) return true;
  return y <= (year || new Date().getFullYear());
};

// plan_28: money going out (kind: 'out') is taken off projections; money
// coming in is added.
export const signOf = (payment) => (payment && payment.kind === 'out' ? -1 : 1);
